export const PLANS_ALWAYS_ON_DELIVERY_KEYS = {
  primary: 'kvp_template1_plans_alwayson',
  modal: 'kvp_template1_plans_alwayson_modal',
} as const;

export const PLANS_ALWAYS_ON_CONTENT_KEYS = {
  monthlyPricing: 'plan.monthlyPricing',
  modalBody: 'modal.body',
} as const;

export const TEMPLATE1_SMART_OFFER_DELIVERY_KEY_PREFIX = 'kvp_template1_';
